import { render, staticRenderFns } from "./IncorrectInventoryTable.vue?vue&type=template&id=cc8c187a&scoped=true&"
import script from "./IncorrectInventoryTable.vue?vue&type=script&lang=ts&"
export * from "./IncorrectInventoryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8c187a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
